import Component from '../abstracts/Component';

export default class CartLayerComponent extends Component {

  get SELECTORS() {
    return {
      content: '[data-items-container]',
      items: '[data-mc-item]',
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
  }

  counterList() {
    let itemsEl = this.$component.querySelectorAll(this.SELECTORS.items);
    if(itemsEl.length > 0) {
      this.toggleEmpty(true);
      this.moduleLoader.loadSimpleBarAndExecute(
        module => {
          this.initSimpleBar(module.default);
        },
        error => {
          console.log('failed to load SimpleBar ', error.stack);
        }
      );
    } else if(itemsEl.length == 0) {
      this.toggleEmpty(false);
    }
  }
  toggleEmpty(bool) {
    // new simple code
    if(bool) {
      this.$component.classList.remove('empty');
    } else {
      this.$component.classList.add('empty');
    }
  }
  initSimpleBar(SimpleBar) {
    new SimpleBar(this.$component.querySelector(this.SELECTORS.content));
  }

  bindEvents() {
    this.$on(this.$customEvents.MINICART_EVENTS.update, (e) => {
      this.counterList();
    });
  }

  render() {
    this.log('Rendering...');
    this.bindEvents();
    this.counterList();
  }
}
